import Q from 'q';

import { get as getUser } from 'js/lib/user';

import type { GTM_DATA_LAYER } from 'bundles/event-tracking/constants';
import { learnerGoogleTagManager } from 'bundles/event-tracking/constants';
import { loadGTMScript, trackEvent } from 'bundles/event-tracking/gtmUtils';
import AdsTracker from 'bundles/event-tracking/tracker';

declare global {
  interface Window {
    [GTM_DATA_LAYER]?: unknown[];
  }
}

function LearnerGoogleTagManager(...args: $TSFixMe[]) {
  // @ts-expect-error ts-migrate(2683) FIXME: 'this' implicitly has type 'any' because it does n... Remove this comment to see the full error message
  AdsTracker.apply(this, args);
}

// @ts-expect-error ts-migrate(7009) FIXME: 'new' expression, whose target lacks a construct s... Remove this comment to see the full error message
LearnerGoogleTagManager.prototype = new AdsTracker();

LearnerGoogleTagManager.prototype.ensureLibLoaded = () => loadGTMScript(learnerGoogleTagManager.url);

LearnerGoogleTagManager.prototype.send = function (params: $TSFixMe) {
  return this.ensureLibLoaded().then(function (dataLayer: $TSFixMe) {
    return dataLayer.push(params);
  });
};

LearnerGoogleTagManager.prototype.prepareParams = function (eventName: $TSFixMe, additionalData: $TSFixMe) {
  const user = getUser();
  return Object.assign(
    {
      userId: user?.id ?? '',
      event: eventName,
    },
    additionalData
  );
};

LearnerGoogleTagManager.prototype.trackSignup = function (userId: $TSFixMe) {
  trackEvent('signup');
  return this.track('Signup', { userId });
};

LearnerGoogleTagManager.prototype.trackEnroll = function ({
  userId,
  productId,
  productCategory,
  productName,
  productSlug,
}: {
  userId: number;
  productId?: string;
  productCategory: string;
  productName?: string;
  productSlug?: string;
}) {
  trackEvent('enroll');
  return this.track('Enroll', { userId, productId, productCategory, productName, productSlug });
};

LearnerGoogleTagManager.prototype.trackDegreeEOICompletion = function (
  degreeSlug: $TSFixMe,
  surveyResponseId: $TSFixMe,
  isQualified: $TSFixMe
) {
  trackEvent('degree_eoi_completion');

  const trackingInfo = {
    degreeSlug,
  };

  if (surveyResponseId) {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'surveyResponseId' does not exist on type... Remove this comment to see the full error message
    trackingInfo.surveyResponseId = surveyResponseId;
  }

  if (isQualified) {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'isQualified' does not exist on type '{ d... Remove this comment to see the full error message
    trackingInfo.isQualified = isQualified;
  }

  return this.track('DegreeEOICompletion', trackingInfo);
};

LearnerGoogleTagManager.prototype.trackDegreeApplyNow = function (
  degreeSlug: string,
  productId?: string,
  productName?: string,
  productCategory?: string
) {
  trackEvent('degree_apply_now');

  const trackingInfo = {
    degreeSlug,
    ...(productId && { productId }),
    ...(productName && { productName }),
    ...(productCategory && { productCategory }),
  };

  return this.track('DegreeApplyNow', trackingInfo);
};

LearnerGoogleTagManager.prototype.trackScheduleACall = function (degreeSlug: $TSFixMe) {
  trackEvent('schedule_a_call');

  const trackingInfo = {
    degreeSlug,
  };

  return this.track('ScheduleACall', trackingInfo);
};

LearnerGoogleTagManager.prototype.trackEnterpriseContractPayment = function (data: $TSFixMe) {
  trackEvent('wes_payment');
  return this.track('WESPayment', data);
};

LearnerGoogleTagManager.prototype.trackAddToCart = function (data: { userId: string; productId: string }) {
  trackEvent('add_to_cart');

  return this.track('AddToCart', data);
};

LearnerGoogleTagManager.prototype._trackPaymentEvent = function (
  type: $TSFixMe,
  userId: $TSFixMe,
  paymentsInfoVal: $TSFixMe,
  orderId: $TSFixMe
) {
  const paymentsInfo = [].concat(paymentsInfoVal);
  const promises = paymentsInfo.map(
    ({ id, value, name, specializationId, currency, isFirstTimePayer, isFinaidCart, subscriptionCycle }) => {
      const specialization = {
        SpecializationId:
          specializationId ||
          ((type === 'specialization' || type === 'specializationSubscription' || type === 'specializationPrepaid') &&
            id) ||
          'Non-Spec',
      };
      const course = type === 'course' ? { CourseId: id } : {};
      const subscription = subscriptionCycle ? { SubscriptionCycle: subscriptionCycle } : {};

      const data = Object.assign(
        {
          Value: parseFloat(value || 0),
          Type: type,
          Name: name,
          Currency: currency,
          FirstTimePayer: isFirstTimePayer,
          IsFinaidCart: isFinaidCart,
        },
        specialization,
        course,
        subscription
      );

      trackEvent('payment', { ...data, userId, cartId: orderId });

      return this.track('Payment', data);
    }
  );
  return Q.allSettled(promises);
};

LearnerGoogleTagManager.prototype.trackS12NBulkPayment = function (...args: $TSFixMe[]) {
  trackEvent('bulkpay');
  return this._trackPaymentEvent('specialization', ...args);
};

LearnerGoogleTagManager.prototype.trackS12NSubscriptionPayment = function (...args: $TSFixMe[]) {
  trackEvent('s12n_subscription_payment');
  return this._trackPaymentEvent('specializationSubscription', ...args);
};

LearnerGoogleTagManager.prototype.trackS12NVCPayment = function (...args: $TSFixMe[]) {
  trackEvent('s12n_course_purchase');
  return this._trackPaymentEvent('course', ...args);
};

LearnerGoogleTagManager.prototype.trackVCPayment = function (...args: $TSFixMe[]) {
  trackEvent('single_course_purchase');
  return this._trackPaymentEvent('course', ...args);
};

LearnerGoogleTagManager.prototype.trackGuidedProjectPayment = function (...args: $TSFixMe[]) {
  trackEvent('guided_project_purchase');
  return this._trackPaymentEvent('guidedProject', ...args);
};

LearnerGoogleTagManager.prototype.trackProjectPayment = function (...args: $TSFixMe[]) {
  trackEvent('project_purchase');
  return this._trackPaymentEvent('project', ...args);
};

LearnerGoogleTagManager.prototype.trackCourseraLiteSubscriptionPayment = function (...args: $TSFixMe[]) {
  trackEvent('coursera_lite_subscription_purchase');
  return this._trackPaymentEvent('courseraLiteSubscription', ...args);
};

LearnerGoogleTagManager.prototype.trackCourseraPlusSubscriptionPayment = function (...args: $TSFixMe[]) {
  trackEvent('coursera_plus_subscription_purchase');
  return this._trackPaymentEvent('courseraPlusSubscription', ...args);
};

LearnerGoogleTagManager.prototype.trackCourseraPlusPrepaidPayment = function (...args: $TSFixMe[]) {
  trackEvent('coursera_plus_prepaid_purchase');
  return this._trackPaymentEvent('courseraPlusPrepaid', ...args);
};

LearnerGoogleTagManager.prototype.trackMasterTrackPayment = function (...args: $TSFixMe[]) {
  trackEvent('master_track_purchase');
  return this._trackPaymentEvent('masterTrack', ...args);
};

LearnerGoogleTagManager.prototype.trackS12NPrepaidPayment = function (...args: $TSFixMe[]) {
  trackEvent('s12n_prepaid_purchase');
  return this._trackPaymentEvent('specializationPrepaid', ...args);
};

LearnerGoogleTagManager.prototype.trackEmailMeInfo = function (
  slug: string,
  productId: string,
  productName: string,
  productCategory: string
) {
  trackEvent('email_me_info');

  const trackingData = {
    slug,
    productId,
    productName,
    productCategory,
  };

  return this.track('EmailMeInfo', trackingData);
};

LearnerGoogleTagManager.prototype.trackEnrollButtonClick = function ({
  userId,
  productId,
  productCategory,
  productName,
  productSlug,
}: {
  userId?: number;
  productId?: string;
  productCategory?: string;
  productName?: string;
  productSlug?: string;
}) {
  trackEvent('enrollButtonClick');
  return this.track('EnrollButtonClick', { userId, productId, productCategory, productName, productSlug });
};

LearnerGoogleTagManager.prototype.trackS12nEnrollModalButtonClick = function ({
  userId,
  productId,
}: {
  userId?: number;
  productId?: string;
}) {
  trackEvent('s12nEnrollModalButtonClick');
  return this.track('S12nEnrollModalButtonClick', { userId, productId });
};

export default LearnerGoogleTagManager;
